export default "__VITE_ASSET__Bbm1Tj6k__"